import { Routes } from '@angular/router';
import { authGuard } from './auth-guard.service';

export const routes: Routes = [
    {
        path: 'acceso',
        title: "Acceso",
        loadChildren: () => import('./pages/access-module/access.routes').then(r => r.routes)
    },
    {
        path: 'layout',
        title: "layout",
        canActivate: [authGuard],
        loadChildren: () => import('./modules/layout/layout.routes').then(r => r.routes)
    },
    {
        path: 'home',
        canActivate: [authGuard],
        loadChildren: () => import('./modules/layout/layout.routes').then(r => r.routes),
        data: {
          breadcrumb: 'Home'
        },
      },
      {
        path: '',
        title: "Acceso",
        loadChildren: () => import('./pages/access-module/access.routes').then(r => r.routes)
      },
      {
        path: '**',
        redirectTo: 'acceso',
        pathMatch: 'full'
      }
    // {
    //     path: 'acceso',
    //     title: "Access",
    //     loadComponent: () => import('./modules/access-module/access.component').then((c) => c.AccessComponent)
    // },
];
